angular.module('natgeo').controller('Level2OfficeScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 
function Level2OfficeScreen($scope, element, ScreenFactory, manager, container, SoundEngine)
{
	var screen = ScreenFactory( 'level2_office', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level2OfficeRunBy', {
			keyframe: {
				'0': {
					translate: 0,
					easing: 'linear'
				},
				'100': {
					translate: {x:-550, y:-60}
				}
			},
			units: {
				translate: '%'
			}
		});
		
		anim8.save('officeRobotPrimaryArmRotate', {
			keyframe: {
				'0': {
					rotate: 0
				},
				'20': {
					rotate: -20
				},
				'30': {
					rotate: -20
				},
				'60': {
					rotate: 20
				},
				'70': {
					rotate: 20
				},
				'90': {
					rotate: 0
				},
				'100': {
					rotate: 0
				}
			},
			initial: {
				origin: {x: 90, y: 90}
			}
		});
	});

	// Beginning of the screen, driveby!
	screen.on('introBegin', function()
	{
		SoundEngine.play( 'driveby', {delay:1500} );
	});

	// Beginning of the screen, play the whip!
	screen.on('introBegin', function()
	{
		SoundEngine.play('whip', {delay:1000});
	});
	
	// The previous screen is the splash screen
	$scope.prev = function()
	{
		manager.transition('level2_splash');
	};
	
	// The next screen is the office screen
	$scope.next = function()
	{
		manager.transition('level2_define');
	};
	
}]);